import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-shop-import',
  templateUrl: './shop-import.component.html',
  styleUrls: ['./shop-import.component.scss']
})
export class ShopImportComponent implements OnInit {
  isVisible = false;
  file: any;
  checked = true;
  isLoadingBtn = false;

  constructor() {
  }

  @Output() body = new EventEmitter();

  ngOnInit() {
  }

  importShopFileExcel(file) {
    // console.log(file);
    this.file = file;
  }
  importShopClick(event) {
    const element = event.target as HTMLInputElement;
    element.value = '';
  }
  showModal() {
    this.file = undefined;
    this.isVisible = true;
    this.checked = true;
    this.isLoadingBtn = false;
  }

  handleCancel() {
    this.isVisible = false;
  }

  removeFile() {
    this.file = undefined;
  }

  onSubmit() {
    // this.isLoadingBtn = true;
    const checked = this.checked ? 0 : 1;
    this.body.emit({file: this.file, param: checked});
  }
  cancelLoading() {
    this.isLoadingBtn = false;
  }
}
